import {
  Auth0Provider,
  Auth0ContextInterface,
  // eslint-disable-next-line no-restricted-imports
  useAuth0 as builtInUseAuth0,
  initialContext
} from "@auth0/auth0-react";
import React, { ReactElement } from "react";
import { useHistory } from "react-router-dom";

const StaffAuth0Context =
  React.createContext<Auth0ContextInterface>(initialContext);

export default function AuthProvider({
  children
}: {
  children: React.ReactNode;
}): ReactElement {
  const history = useHistory();
  function onRedirectCallback(appState: any) {
    // Redirect to the page the user was on before they were redirected to Auth0
    const returnTo = appState?.returnTo || window.location.pathname;
    history.push(returnTo);
  }

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/admin`,
        // Note: we intentionally ignore base url overrides here
        // and always use the primary "shared" environment's base url
        // as the audience for dedicated envs.
        audience: process.env.REACT_APP_ADMIN_API_BASE_URL!
      }}
      useRefreshTokens
      cacheLocation="localstorage"
      skipRedirectCallback={document.location.pathname === "/admin/staff-auth0"}
      onRedirectCallback={onRedirectCallback}
    >
      <Auth0Provider
        domain={process.env.REACT_APP_STAFF_AUTH0_DOMAIN!}
        clientId={process.env.REACT_APP_STAFF_AUTH0_CLIENT_ID!}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/admin/staff-auth0`,
          audience: process.env.REACT_APP_STAFF_AUTH0_AUDIENCE
        }}
        useRefreshTokens
        cacheLocation="localstorage"
        context={StaffAuth0Context}
        skipRedirectCallback={
          document.location.pathname !== "/admin/staff-auth0"
        }
        onRedirectCallback={onRedirectCallback}
      >
        {children}
      </Auth0Provider>
    </Auth0Provider>
  );
}

export function useAuth0(): Auth0ContextInterface {
  const auth0 = builtInUseAuth0();
  const staffAuth0 = builtInUseAuth0(StaffAuth0Context);

  if (staffAuth0.user) {
    return staffAuth0;
  }

  return auth0;
}

export function useStaffAuth0Active(): boolean {
  const staffAuth0 = builtInUseAuth0(StaffAuth0Context);
  return !!staffAuth0.user;
}

export function useNonStaffAuth0(): Auth0ContextInterface {
  return builtInUseAuth0();
}

export function useStaffAuth0(): Auth0ContextInterface {
  return builtInUseAuth0(StaffAuth0Context);
}
